// Section 24.14: view models are memoised on their inputs. A one-entry cache keyed by argument
// identity is enough: signals hand the same objects back until something changes.
export function memo<A extends unknown[], R>(fn: (...args: A) => R): (...args: A) => R {
  let lastArgs: A | null = null;
  let last: R | undefined;
  return (...args: A): R => {
    const prev = lastArgs;
    if (
      prev !== null &&
      prev.length === args.length &&
      args.every((a, i) => Object.is(a, prev[i]))
    )
      return last as R;
    lastArgs = args;
    last = fn(...args);
    return last;
  };
}
